<template>
  <div id="worldNormalView">
    <div class="contents">
      <div id="reset_btn_view">
        <div :class="{ activ_btn: isActive }" id="reset_btn" @click="resetGame">リセット</div>
        <div id="close_btn" @click="closeView">
          <div class="close_link">
            <p>
              <font-awesome-icon icon="times" />
            </p>
          </div>
        </div>
      </div>

      <div id="title_view">
        <h1>{{ title }}</h1>
      </div>

      <div id="contens_select_view">
        <div class="btns" @click.prevent.stop="toggleState('shape_view_show')">
          <checkbox id="shape" v-model="shape_view_show" color="#ff8b00" :disabled="checkbox_disable">国の形</checkbox>
        </div>
        <div class="btns" @click.prevent.stop="toggleState('capital_view_show')">
          <checkbox id="capital" v-model="capital_view_show" color="#42b983" :disabled="checkbox_disable">首都</checkbox>
        </div>
        <div class="btns" @click.prevent.stop="toggleState('flag_view_show')">
          <checkbox id="flag" v-model="flag_view_show" color="#f50057" :disabled="checkbox_disable">国旗</checkbox>
        </div>
        <div class="btns" @click.prevent.stop="toggleState('name_view_show')">
          <checkbox id="name" v-model="name_view_show" color="#4069e1" :disabled="checkbox_disable">国名</checkbox>
        </div>
      </div>

      <div id="rest_count_view">
        あと
        <b>{{ rest }}</b>枚
      </div>

      <div id="roulette_views">
        <div id="shape_view" v-show="shape_view_show">
          {{ shape_title_src }}
          <img :src="shape_img_src" alt v-show="imgs_show">
        </div>
        <div id="capital_view" v-show="capital_view_show">{{ capital_src }}</div>
        <div id="flag_view" v-show="flag_view_show">
          {{ flag_title_src }}
          <img :src="flag_img_src" alt v-show="imgs_show">
        </div>
        <div id="name_view" v-show="name_view_show">{{ name_src }}</div>
      </div>

      <div id="ctrl_btns">
        <div class="activ_btn" id="answer_btn" v-show="answer_btn_show" @click="showAnswer">正解を表示</div>
        <div :class="{ activ_btn: isActive }" id="start_btn" @click="playGame">{{ start_btn_label }}</div>
      </div>

      <!-- 正解 -->
      <vodal class="vodal_view my-dialog" measure="px" :show="answer_view_show" :animation="animation" :width="280" :height="440" :duration="301" @hide="answer_view_show = false">
        <div class="vodal_view">
          <div class="vodal_header">
            正解は…
            <p id="answer_name_label">{{ answer_name }}</p>
          </div>
          <div class="vodal_content">
            <img :src="answer_trump_src" alt>
          </div>
          <div class="vodal_footer_s">
            <div @click="nextGame">Next !</div>
          </div>
        </div>
      </vodal>

      <!-- 終了 -->
      <vodal measure="px" :show="finish_alert_show" :animation="animation" :width="300" :height="240" :duration="600" class="my-dialog" @hide="finish_alert_show = false">
        <div class="vodal_view">
          <div class="vodal_mark" style="font-size: 30px color: #B78333">
            <font-awesome-icon icon="trophy" />
          </div>
          <div class="vodal_header">ゲーム終了！</div>
          <div class="vodal_content">
            リセットボタンを押して
            <br>最初から始めよう！
          </div>
          <div class="vodal_footer">
            <div @click="finish_alert_show = false">OK</div>
          </div>
        </div>
      </vodal>

      <!-- リセット -->
      <vodal measure="px" :show="reset_alert_show" :animation="animation" :width="300" :height="240" :duration="300" class="my-dialog" @hide="reset_alert_show = false">
        <div class="vodal_view">
          <div class="vodal_header">
            <font-awesome-icon icon="redo-alt" />
            <p>リセット</p>
          </div>
          <div class="vodal_content">
            ゲームをリセットします。
            <br>よろしいですか？
          </div>
          <div class="vodal_footer">
            <div @click="reset_alert_show = false">Cancel</div>
            <div @click="resetGameB">OK</div>
          </div>
        </div>
      </vodal>
    </div>
  </div>
</template>

<script>
import Vodal from "vodal"
import soundMixin from '../libs/soundMixin.js'
import gameMixin from '../libs/gameMixin.js'

/**
 * 世界がわかる ルーレット 初級編
 *
 * @vue-data {String} [title='世界がわかる ルーレット 初級編'] ルーレットのタイトル
 * @vue-data {Boolean} [shape_view_show=true] 国の形ルーレットの表示フラグ
 * @vue-data {Boolean} [capital_view_show=true] 首都ルーレットの表示フラグ
 * @vue-data {Boolean} [flag_view_show=true] 国旗ルーレットの表示フラグ
 * @vue-data {Boolean} [name_view_show=true] 国名ルーレットの表示フラグ
 * @vue-data {String} [start_btn_label='スタート'] スタートボタンのラベルテキスト
 * @vue-data {Object} [shape_img_src=null] 国の形イメージ
 * @vue-data {Object} [flag_img_src=null] 国旗イメージ
 * @vue-data {String} [shape_title_src='国の形'] 国の形ルーレットのテキスト
 * @vue-data {String} [flag_title_src='国旗'] 国旗ルーレットのテキスト
 * @vue-data {String} [capital_src='首都'] 首都ルーレットのテキスト
 * @vue-data {String} [name_src='国名'] 国名ルーレットのテキスト
 * @vue-data {Boolean} [flagTimerRunning=false] 国旗ルーレットの作動中フラグ
 * @vue-data {Boolean} [shapeTimerRunning=false] 国の形ルーレットの作動中フラグ
 * @vue-data {Object} [capitalTimer=null] 首都ルーレットのタイマー
 * @vue-data {Object} [nameTimer=null] 国名ルーレットのタイマー
 * @vue-data {Int} [currentDataIndex=-1] 正解のカードのインデックス
 * @vue-data {Array} [displayedIndex=[]] 表示済みカードのインデックス配列
 * @vue-data {Int} [maxCount=52] カードの総数
 * @vue-data {Int} [stopInterval=3000] ルーレットの停止間隔（3秒）
 * @vue-data {Int} [rest=52] カードの残りの枚数
 * @vue-data {Boolean} [answer_view_show=false] 正解ポップアップの表示フラグ
 * @vue-data {Boolean} [answer_btn_show=false] 「正解を表示」ボタンの表示フラグ
 * @vue-data {String} [animation=''] ポップアップのアニメーションタイプ（flip, rotate, slidedown）
 * @vue-data {Object} [answer_trump_src=''] 正解のトランプイメージ
 * @vue-data {String} [answer_name=''] 正解の国名テキスト
 * @vue-data {Boolean} [finish_alert_show=false] ゲーム終了ポップアップの表示フラグ
 * @vue-data {Boolean} [reset_alert_show=false] リセットポップアップの表示フラグ
 * @vue-data {Boolean} [checkbox_disable=false] チェックボックスのアクティブフラグ（ルーレット作動中に無効にする）
 * @vue-data {Object} [rouletteSounds=null] ルーレット音のAudioオブジェクト
 * @vue-data {Object} [rouletteStopSounds=null] ルーレット停止音のAudioオブジェクト
 * @vue-data {Object} [popupSounds=null] ポップアップ表示音のAudioオブジェクト
 * @vue-data {Boolean} [imgs_show=false] イメージタグの表示フラグ（レイアウトがずれるのでリセット時にイメージを非表示する）
 * @vue-data {Object} [flag_roulette_anime] 国旗ルーレットのgifイメージ
 * @vue-data {Object} [shape_roulette_anime] 国の形ルーレットのgifイメージ
 * @vue-data {Boolean} [isActive=true] ボタンイベントのアクティブフラグ（ルーレット作動中に無効にする）
 * @vue-computed {Boolean} soundsMute 効果音・BGMのミュートフラグ（true, false）
 * @vue-computed {Array} data 世界データ
 * @vue-computed {Object} snd サウンドオブジェクト
 */
export default {
  name: "worldNormal",

  components: {
    Vodal
  },

  mixins: [
    soundMixin,
    gameMixin
  ],

  data () {
    return {
      title: "世界がわかる ルーレット 初級編",
      back_page: "world",
      shape_view_show: true,
      capital_view_show: true,
      flag_view_show: true,
      name_view_show: true,
      start_btn_label: "スタート",
      shape_img_src: null,
      flag_img_src: null,
      shape_title_src: "国の形",
      flag_title_src: "国旗",
      capital_src: "首都",
      name_src: "国名",
      flagTimerRunning: false,
      shapeTimerRunning: false,
      capitalTimer: null,
      nameTimer: null,
      currentDataIndex: -1,
      displayedIndex: [],
      maxCount: 0,
      rest: 0,
      stopInterval: 3000,
      answer_view_show: false,
      answer_btn_show: false,
      animation: "",
      answer_trump_src: "",
      answer_name: "",
      finish_alert_show: false,
      reset_alert_show: false,
      checkbox_disable: false,
      rouletteSounds: null,
      rouletteStopSounds: null,
      popupSounds: null,
      imgs_show: false,
      flag_roulette_anime: require("../assets/world/flag_images/flag_roulette_anime.gif"),
      shape_roulette_anime: require("../assets/world/shape_images/shape_roulette_anime.gif"),
      isActive: true
    }
  },

  mounted () {
    // console.log(this.$options.name)
    this.maxCount = this.rest = this.data.length
    // console.log('maxCount:' + this.maxCount + ' rest:' + this.rest)
    this.$store.dispatch("setCurrentGame", { gameName: this.$options.name }) // Component名保存
  },

  computed: {
    soundsMute () {
      return this.$store.getters.soundsMute
    },
    data () {
      return this.$store.getters.worldData
    },
    snd () {
      return this.$store.getters.snd
    }
  },

  watch: {
    soundsMute () {
      if (this.soundsMute) {
        this.stopRouletteSound()
      } else {
        if (this.timerIsRunnig()) {
          this.playRouletteSound()
        }
      }
    },
    shape_view_show () {
      if (this.shape_view_show) {
        if (this.currentDataIndex >= 0) {
          this.shape_title_src = ""
          const current = this.data[this.currentDataIndex]
          this.shape_img_src = require("../assets/world/shape_images/" +
            current.img_name)
        }
      }
    },
    flag_view_show () {
      if (this.flag_view_show) {
        if (this.currentDataIndex >= 0) {
          this.flag_title_src = ""
          const current = this.data[this.currentDataIndex]
          this.flag_img_src = require("../assets/world/flag_images/" +
            current.img_name)
        }
      }
    },
    capital_view_show () {
      if (this.capital_view_show) {
        if (this.currentDataIndex >= 0) {
          const current = this.data[this.currentDataIndex]
          this.capital_src = current.capital
        }
      }
    },
    name_view_show () {
      if (this.name_view_show) {
        if (this.currentDataIndex >= 0) {
          const current = this.data[this.currentDataIndex]
          this.name_src = current.name
        }
      }
    }
  },
  methods: {
    /**
     * ルーレット表示チェック
     * @return {Boolean} true/false いずれかのルーレットが表示中なら真
     */
    rouletteIsDisplayed () {
      return this.shape_view_show ||
        this.flag_view_show ||
        this.name_view_show ||
        this.capital_view_show
    },

    /**
     * タイマー作動中チェック
     * @return {Boolean} true/false  （タイマー作動中：真）
     */
    timerIsRunnig () {
      return this.shapeTimerRunning ||
        this.flagTimerRunning ||
        this.capitalTimer ||
        this.nameTimer
    },

    /**
     * ルーレットをリセット
     * 確認ポップアップの「OK」ボタンのイベント
     */
    resetGameB () {
      this.reset_alert_show = false
      this.rest = this.maxCount
      this.answer_btn_show = false
      this.isActive = true
      this.displayedIndex = []
      this.currentDataIndex = -1
      this.shape_view_show = true
      this.capital_view_show = true
      this.flag_view_show = true
      this.name_view_show = true
      this.start_btn_label = "スタート"
      this.shape_img_src = null
      this.flag_img_src = null
      this.shape_title_src = "国の形"
      this.flag_title_src = "国旗"
      this.capital_src = "首都"
      this.name_src = "国名"
      this.checkbox_disable = false
      this.imgs_show = false
    },

    /**
     * 「正解を表示」ボタンイベント
     * 正解ポップアップを表示
     */
    showAnswer () {
      this.playPopupSound()
      const current = this.data[this.currentDataIndex]
      this.answer_name = current.name
      this.answer_trump_src = require("../assets/world/card_images/" +
        current.img_name)
      this.animation = "rotate"
      this.answer_view_show = true
    },

    /**
     * 国旗イメージをルーレット中のgifに変更する
     */
    changeFlagImage () {
      this.flag_title_src = ""
      this.flag_img_src = this.flag_roulette_anime
    },

    /**
     * 首都テキストをランダムで取得して表示
     */
    changeCapital () {
      const randnum = Math.floor(Math.random() * this.maxCount)
      const current = this.data[randnum]
      this.capital_src = current.capital
    },

    /**
     * 表示チェックが入っているアイテムのルーレット表示を開始
     * <ul>
     * <li>国旗・国形はgifアニメを設定するだけ</li>
     * <li>首都・国名は0.1秒単位でchangメソッドを呼ぶタイマーをスタートする</li>
     * <li>4秒単位でそれぞれのストップイベントを呼ぶタイマーをセットする</li>
     * </ul>
     */
    startTimers () {
      let interval = this.stopInterval
      if (this.shape_view_show) {
        this.changeShapeImage()
        this.shapeTimerRunning = true
        setTimeout(this.stopShapeTimer, interval)
        interval += this.stopInterval
      }
      if (this.capital_view_show) {
        this.capitalTimer = setInterval(() => {
          this.changeCapital()
        }, 100)
        setTimeout(this.stopCapitalTimer, interval)
        interval += this.stopInterval
      }
      if (this.flag_view_show) {
        this.changeFlagImage()
        this.flagTimerRunning = true
        setTimeout(this.stopFlagTimer, interval)
        interval += this.stopInterval
      }
      if (this.name_view_show) {
        this.nameTimer = setInterval(() => {
          this.changeName()
        }, 100)
        setTimeout(this.stopNameTimer, interval)
        interval += this.stopInterval
      }
    },

    /**
     * 正解の国旗イメージを表示
     */
    stopFlagTimer () {
      this.flagTimerRunning = false
      const current = this.data[this.currentDataIndex]
      this.flag_img_src = require("../assets/world/flag_images/" +
        current.img_name)
      this.playStopSound()
      this.updateVCtrlBtns()
    },

    /**
     * 正解の国形イメージを表示
     */
    stopShapeTimer () {
      this.shapeTimerRunning = false
      const current = this.data[this.currentDataIndex]
      this.shape_img_src = require("../assets/world/shape_images/" +
        current.img_name)
      this.playStopSound()
      this.updateVCtrlBtns()
    },

    /**
     * 首都のタイマーを破棄して正解のテキストを表示
     */
    stopCapitalTimer () {
      clearInterval(this.capitalTimer)
      this.capitalTimer = null
      const current = this.data[this.currentDataIndex]
      this.capital_src = current.capital
      this.playStopSound()
      this.updateVCtrlBtns()
    }
  }
}
</script>

<style lang="sass" src='../assets/common_style.sass'></style>
<style lang="sass" scoped>

#worldNormalView
  margin: 40px auto
  padding: 20px
  background-color: #feffff
  border-radius: 40px
  max-width: 720px
  box-shadow: 8px 8px 8px rgba(0, 0, 0, 0.3)

.contents
  width: 100%
  margin: 0 auto
  max-width: 800px
  cursor: default

.mainlayout
  display: flex
  flex-direction: row
  justify-content: center
  align-items: center
  flex-wrap: wrap

a
  color: #ffffff
  text-decoration: none

#title_view
  img
    height: 80px
    

#rest_count_view
  @extend .mainlayout
  font-size: 30px

#roulette_views
  @extend .mainlayout
  margin: 30px auto
  
.roulette_view
  @extend .mainlayout
  width: 132px
  height: 132px
  min-width: 132px
  margin: 8px
  font-weight: 800
  font-size: 16px
  border-radius: 14px
  // padding: 10px

#shape_view
  @extend .roulette_view
  border: 4px solid #ff8c00

#flag_view
  @extend .roulette_view
  border: 4px solid #f50057

#name_view
  @extend .roulette_view
  border: 4px solid #4169E1

#capital_view
  @extend .roulette_view
  border: 4px solid #42b983

#roulette_views
  img
    max-width: 124px
    height: auto

.vodal_content
  img
    max-width: 200px
    height: auto

h1
  margin: 20px 20px 0 20px

#ctrl_btns
  @extend .mainlayout
  max-width: 500px
  margin: 30px auto
  div
    @extend .mainlayout
    width: 180px
    height: 70px
    min-width: 180px
    margin: 10px auto
    font-weight: 800
    font-size: 20px
    border-radius: 40px
    // cursor: pointer

#start_btn
  color: #252525
  background-color: rgb(255, 200, 60)
  box-shadow: 0 3px 0 rgb(206, 162, 51)

#answer_btn
  color: #feffff
  background-color: rgb(255, 38, 67)
  box-shadow: 0 3px 0 rgb(199, 31, 54)

#contens_select_view
  @extend .mainlayout
  margin: 20px auto

.checkbox-container,
.checkbox-group
  pointer-events: none

.btns
  width: 106px

</style>
